import { WizardProps } from 'components/Wizards/Types'
import { useRootStore } from 'stores/RootStore'
import { useGenerateContent } from 'components/Wizards/Wizard/useGenerateContent'
import { Wizard } from '../Wizard/Wizard'
import { GenerateNewDocButton } from './GenerateNewDocButton'
import Styles from './RetryWizard.module.scss'
import { AlmanacFile, GeneratePrompt } from 'types'
import { BackButton } from 'components/Wizards/RetryWizard/BackButton'
import cx from 'classnames'
import { CopyPromptButton } from 'components/Wizards/RetryWizard/CopyPromptButton'
import { promptText } from 'components/ActivityEvent/utils'
import { useFormikContext } from 'formik'
import { Button } from 'components/Button'
import { WizardProvider } from 'components/Wizards/Wizard/WizardContext'

interface Props
  extends Omit<
    WizardProps,
    'initialValues' | 'articleId' | 'layerId' | 'nodeSelection' | 'bodyClassName' | 'stepperVariant' | 'headerClassName'
  > {
  articleId: string
  layerId: string
  initialValues: {
    project: AlmanacFile
  } & Partial<GeneratePrompt>
}

const SubmitButton = () => {
  const { submitForm, isSubmitting } = useFormikContext()

  return (
    <Button size="lg" onPress={() => submitForm()} isDisabled={isSubmitting}>
      Try Again on This Doc
    </Button>
  )
}

export const RetryWizard = ({ schema, initialValues, layerId, articleId }: Props) => {
  const handbooksStore = useRootStore().handbooks
  const { promptLibrary, type, previewUrl, steps, title, icon } = schema.describe().meta

  const { generateContent } = useGenerateContent({
    generationType: type,
    articleId,
    layerId,
    promptLibrary,
  })

  return (
    <WizardProvider schema={schema}>
      <Wizard.Root aria-labelledby="wizard-header" type={type}>
        <Wizard.Header previewUrl={previewUrl} steps={steps} title={title} icon={icon} />
        <Wizard.Form
          schema={schema}
          onSubmit={async (values) => {
            await generateContent(values)
            handbooksStore.refresh(values.project?.handbook?.key)
          }}
          initialValues={schema.cast({ ...schema.getDefault(), ...initialValues })}
        >
          <div className={Styles.buttonContainer}>
            <BackButton />
            <div className={cx(Styles.buttonContainer, Styles.rightButtons)}>
              <GenerateNewDocButton schema={schema} project={initialValues.project} />
              <CopyPromptButton prompt={promptText({ ...initialValues, generation_type: type })} />
              <SubmitButton />
            </div>
          </div>
        </Wizard.Form>
      </Wizard.Root>
    </WizardProvider>
  )
}
